import { useTranslation } from '@shared/core';
import { useDynamicBanner } from '../routes/Dashboard/components/DynamicBanner/useDynamicBanner';
import { useFreeShippingCountries } from '../routes/Dashboard/components/ProductDetailsPage/useFreeShippingCountries';
import { useEffect } from 'react';
import { StationeryProduct } from '@shared/utils/print-price/types';
import { Shipping } from '@withjoy/joykit/icons';

export const useFreeShippingBanner = (products: StationeryProduct[]) => {
  const freeShippingCountries = useFreeShippingCountries(products);
  const { showBanner, hideBanner } = useDynamicBanner();
  const { t } = useTranslation('stationery');
  const tBanner = t('dashboard', 'dynamicBanner');

  useEffect(() => {
    if (freeShippingCountries.length > 0) {
      showBanner({
        icon: Shipping,
        message: tBanner.freeShipping({ countries: freeShippingCountries.join(', ') })
      });
    }

    return hideBanner;
  }, [freeShippingCountries, showBanner, hideBanner, tBanner]);
};
